import { action, computed, observable } from 'mobx'
import contactApi from '../api/contact'

export class ContactModel {
  @computed get key() {
    return this.phoneNumber
  }
  id = ''
  @observable contactName = ''
  email = ''
  @observable phoneNumber = ''
  @observable contactGroupList: Group[] = []
  @observable checked = false
  constructor(data: any) {
    this.reJSON(data)
  }

  @action updateChecked(checked: boolean) {
    this.checked = checked
  }

  @action reJSON(data: any) {
    if (!data) {
      return
    }
    this.id = data.id
    this.contactName = data.contactName
    this.email = data.email
    this.phoneNumber = data.phoneNumber
    this.contactGroupList = data.contactGroupList
  }
}

export class Group {
  id: string = ''
  @observable name: string = ''
  @observable contactList: ContactModel[] = []
  @computed get count() {
    return this.contactList.length
  }
  @observable checked: boolean = false

  @action updateChecked(checked: boolean) {
    this.checked = checked
  }
  constructor(data: any) {
    // const keys = Object.keys(data);
    // for(let key of keys) {
    //   // @ts-ignore
    //   this[key] = data[kye];
    // }
    if (data) {
      this.id = data.id
      this.name = data.name
      this.contactList = data.contactList.map((cdata: any) => new ContactModel(cdata))
    }
  }
}

export default class GroupsStore {
  @observable requested = false
  @observable requestLoading = false
  @observable groupsTotal = 0
  @observable groupsPageNo = 1
  @observable groupsPageSize = 12
  @observable groups: Group[] = []

  @observable editContactModel: ContactModel | null = null
  @observable addContactModelGroupIds: string[] = []
  @observable isShowEditContactModal = false

  @observable editGroupModel: Group | null = null
  @observable isShowEditGroupModel = false

  @action updateGroupPageNo(no: number) {
    this.groupsPageNo = no
  }
  @action updateGroupPageSize(size: number) {
    this.groupsPageSize = size
  }

  @observable allRequested = false
  @observable allRequestLoading = false
  @observable allGroups: Group[] = []

  @action async requestAllGroups(force: boolean = false) {
    if (!force && this.allRequested) {
      return this.allGroups
    }
    this.allRequested = false
    this.allRequestLoading = true
    try {
      const { content, totalElements } = (await contactApi.groups(this.groupsPageNo - 1, 100)) as any
      this.allGroups = content.map((item: any) => {
        return new Group(item)
      })
      this.allRequested = true
    } finally {
      this.allRequestLoading = false
    }
    return this.allGroups
  }

  /**
   * 展示联系人弹窗
   * @param contact 有表示 编辑，无 表示新增
   */
  @action openEditContactModal(contact?: ContactModel, defaultGroupIds?: string[]) {
    if (contact) {
      this.editContactModel = contact
    } else {
      this.editContactModel = null
    }
    if (Array.isArray(defaultGroupIds)) {
      this.addContactModelGroupIds = defaultGroupIds
    } else {
      this.addContactModelGroupIds = []
    }
    this.isShowEditContactModal = true
  }
  @action hideEditContactModal() {
    this.isShowEditContactModal = false
    this.editContactModel = null
    this.addContactModelGroupIds = []
  }

  private AddGroupCallback?: Function

  @action setAddGroupCallback(callback: Function) {
    this.AddGroupCallback = callback
  }

  /**
   * 展示分组弹窗
   * @param group 有表示 编辑，无 表示新增
   */
  @observable openEditGroupModal(group?: Group) {
    if (group) {
      this.editGroupModel = group
    } else {
      this.editGroupModel = null
    }
    this.isShowEditGroupModel = true
  }
  @observable hideEditGroupModel(success = false) {
    this.isShowEditGroupModel = false
    this.editGroupModel = null
    if (success) {
      if (typeof this.AddGroupCallback === 'function') {
        this.AddGroupCallback()
      }
    }
    this.AddGroupCallback = void 0
  }

  // 被选中的列表
  @computed get checkedGroups() {
    return this.groups.filter((g) => g.checked)
  }

  // 是否选择全部
  @computed get isAllChecked() {
    if (this.groups.length === 0) {
      return false
    }
    return this.checkedGroups.length === this.groups.length
    // return this.groups.every((g) => g.checked)
  }

  // 是否至少一个被选中
  @computed get isHasChecked() {
    return this.checkedGroups.length > 0
  }

  // 全部 选中/取消选中
  @action doCheckAll(checked: boolean) {
    this.groups.map((g) => g.updateChecked(checked))
  }

  // 删除选中的分组
  @action async doDeleteGroups(groups: Group[] = []) {
    const ids = (groups.length ? groups : this.checkedGroups).map((g) => g.id)
    if (ids.length === 0) {
      return
    }
    await contactApi.delete(ids)
    //
  }

  @action async requestGroups(force: boolean = false) {
    if (!force && this.requested === true) {
      return this.groups
    }

    this.requestLoading = true
    try {
      const { content, totalElements } = (await contactApi.groups(this.groupsPageNo - 1, this.groupsPageSize)) as any
      this.groups = content.map((item: any) => {
        return new Group(item)
      })
      this.groupsTotal = totalElements
      this.requested = true
    } finally {
      this.requestLoading = false
    }

    return this.groups
  }
}
